import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ProductCard = ({ product }) => {
  const navigate = useNavigate();
  const [imgError, setImgError] = useState(false);

  const handleCardClick = () => {
    navigate(`/product/${product._id || product.id}`);
  };

  const getImageUrl = () => {
    if (!product.images) return null;

    let imageUrl = '';

    if (typeof product.images === 'string') {
      imageUrl = product.images;
    } else if (Array.isArray(product.images) && product.images.length > 0) {
      imageUrl = typeof product.images[0] === 'string' ? product.images[0] : '';
    }

    if (!imageUrl || typeof imageUrl !== 'string') return null;

    return imageUrl.startsWith('http')
      ? imageUrl
      : `${process.env.REACT_APP_API_URL}/${imageUrl}`;
  };

  const finalImageUrl = getImageUrl();

  return (
    <div
      className="bg-white transition-shadow duration-300 cursor-pointer
                 w-[244px] h-[318px] md:w-auto md:h-auto"
      onClick={handleCardClick}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleCardClick(); } }}
      role="button"
      tabIndex={0}
    >
      <div className="relative h-[249px] md:h-[249px] bg-gray-50 rounded-[14px] overflow-hidden hover:shadow-md">
        {finalImageUrl && !imgError ? (
          <img
            src={finalImageUrl}
            alt={product.product_name}
            className="w-full h-full object-contain"
            onError={() => setImgError(true)}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-gray-100">
            <span className="text-gray-400">{imgError ? 'Image not found' : 'No image available'}</span>
          </div>
        )}
      </div>
      <div className="pt-4">
      <h3 
          className="w-[244px] h-[29px] font-inter font-medium text-[18px] leading-[28px] text-gray-800"
          style={{ opacity: 1 }}
        >
          {product.product_name}
        </h3>
        <p 
          className="font-inter font-normal text-[14px] md:text-[16px] leading-[20px] md:leading-[24px] text-gray-500 mt-1"
        >
          {product.category || product.category_name}
        </p>
      </div>
    </div>
  );
}

export default ProductCard;
